<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-file-powerpoint', fontSet: 'fad'}"
	[headerText]="data?.media?.name || data?.mediaName"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<div #powerPointContainer class="powerPointContainer">
			@if (!powerPointLoaded && pptxLoadingError) {
				<div class="errorLoading">
					<i class="fad fa-file-powerpoint fa-3x"></i>
					<div class="text">
						{{ T.EDIT_MEDIA_DIALOG_POWERPOINT_LOAD_ERROR | translate }}
					</div>
				</div>
			}

			<sim-component-loading-container
				[isLoading]="!powerPointLoaded && !pptxLoadingError"
				[loadingIcon]="'fad fa-file-powerpoint'"
				[loadingMessage]="T.GLOBAL_TEXT_LOADING | translate"
			/>

			<button (click)="pageNum = pageNum - 1" [disabled]="pageNum === 0" class="controlBtns leftControlBtn" color="accent" mat-fab>
				<mat-icon fontIcon="fa-chevron-left" fontSet="fas" inline style="font-size: 1.2em" />
			</button>

			@if (powerPointReady) {
				<sim-presentation-viewer
					(loaded)="powerPointLoaded = $event"
					(loadingError)="powerPointError()"
					(numberOfPages)="numberOfPowerPointPages = $event"
					[autoPlayInterval]="5000"
					[enableAutoPlay]="false"
					[file]="data?.mediaUrl"
					[height]="powerPointHeight"
					[media]="data?.media"
					[pageNum]="pageNum"
					[width]="powerPointWidth"
				/>
			}

			<button
				(click)="pageNum = pageNum + 1"
				[disabled]="pageNum === numberOfPowerPointPages"
				class="controlBtns rightControlBtn"
				color="accent"
				mat-fab
			>
				<mat-icon fontIcon="fa-chevron-right" fontSet="fas" inline style="font-size: 1.2em" />
			</button>
		</div>
	</ng-container>
</sim-basic-material-dialog>
